import * as api from './api';
import * as types from './mutations';

const state = {
    categories: [],
    defaultListing: [],
    activeFAQs: [],
    activeFilters: [8],
    isProcessing: false
};

const getters = {

};

const actions = {
    getCategories({commit, state}) {
        if (state.categories.length) return state.categories;

        return new Promise((resolve) => {
            axios.get(api.getCategories)
                .then(({data}) => {
                    const categories = data.faqCategories.data;
                    commit(types.UPDATE_CATEGORIES, categories);
                    resolve(categories);
                });
        });
    },

    getDefaultListing({commit}) {
        commit(types.UPDATE_ACTIVE_FILTERS, []);
        commit(types.UPDATE_ACTIVE_FAQS, []);

        if (state.defaultListing.length) return state.defaultListing;

        return new Promise((resolve) => {
            axios.get(api.getFeaturedFaqs)
                .then(({data}) => {
                    let faqs = data.data;

                    faqs = faqs.sort((a,b) => a.orderNumber - b.orderNumber);

                    commit(types.SET_DEFAULT_LISTING, faqs);
                    resolve(faqs);
                });
        });
    },

    getFaqsByCategories({ commit, state }, categoryIds) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            const ids = categoryIds.join(',');
            const endpoint = api.getCategories + `?in=${ids}&relations=faqs`;

            axios.get(endpoint)
                .then(({ data }) => {
                    let faqs = _.flatMap(data.faqCategories.data, category => category.faqs.data);
                    
                    faqs = faqs.sort((a,b) => a.orderNumber - b.orderNumber);
                    
                    commit(types.UPDATE_ACTIVE_FAQS, _.uniqBy(faqs, faq => faq.id));
                    commit(types.UPDATE_ACTIVE_FILTERS, categoryIds);
                    resolve(faqs);
                })
                .catch(({ response }) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },
};

const mutations = {
    [types.SET_DEFAULT_LISTING](state, faqs) {
        state.defaultListing = faqs;
    },

    [types.UPDATE_CATEGORIES](state, categories) {
        state.categories = categories;
    },

    [types.UPDATE_ACTIVE_FAQS](state, faqs) {
        state.activeFAQs = [...faqs];
    },

    [types.UPDATE_ACTIVE_FILTERS](state, filters) {
        state.activeFilters = [...filters];
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations
};